import type {
  CloneRoleInput,
  RoleDetail,
  UserOverridesInput,
  UserPermissions,
} from '#shared/types';
import { api } from '#client/lib/api';
import { ENDPOINT } from '#client/lib/endpoints';

/** Creates a role as a copy of another, under a new name. */
export function cloneRole(sourceId: number, input: CloneRoleInput): Promise<RoleDetail> {
  return api.post<RoleDetail>(ENDPOINT.roleClone(sourceId), input);
}

/** Replaces one user's allow and deny overrides. */
export function saveUserOverrides(
  userId: number | string,
  input: UserOverridesInput,
): Promise<UserPermissions> {
  return api.put<UserPermissions>(ENDPOINT.userPermissions(userId), input);
}
